<template>
    <div id="global-empty-layout-container" class="overflow-hidden">
        <slot></slot>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "EmptyLayout",
});
</script>